import {
  DuplicateContactException,
  ExceptionWithMessage,
} from 'shared/helpers/CustomErrors';

const I18N_PREFIX = 'CONTACTS_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM';

// Attributes the API reports as already taken, mapped to a translated message.
const DUPLICATE_MESSAGE_KEYS = {
  email: `${I18N_PREFIX}.EMAIL_ADDRESS.DUPLICATE`,
  phone_number: `${I18N_PREFIX}.PHONE_NUMBER.DUPLICATE`,
};

/**
 * Picks the most specific message for a failed contact save, so the user
 * learns why it failed (duplicate email / phone number, or whatever the API
 * reported) instead of a generic "try again later".
 * @param {Error} error - error thrown by the contacts store actions
 * @param {Function} t - i18n translate function
 * @param {string} fallbackMessage - generic message used when no reason is known
 * @returns {string}
 */
export const getContactSaveErrorMessage = (error, t, fallbackMessage) => {
  if (error instanceof DuplicateContactException) {
    const attributes = Array.isArray(error.data) ? error.data : [];
    const messages = Object.entries(DUPLICATE_MESSAGE_KEYS)
      .filter(([attribute]) => attributes.includes(attribute))
      .map(([, key]) => t(key));
    if (messages.length) return messages.join(' ');
    return error.serverMessage || fallbackMessage;
  }
  if (error instanceof ExceptionWithMessage && error.data) {
    return error.data;
  }
  return fallbackMessage;
};
